var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7906 2.42469L14.792 2.42578C16.2628 3.57611 17.5338 5.27436 18.4533 7.4269C18.4734 7.47583 18.4692 7.52816 18.4568 7.55627L18.4567 7.55626L18.4543 7.56191C16.6116 11.8773 13.3865 14.3472 9.89646 14.3472H9.88761C6.40666 14.3472 3.18146 11.8776 1.33861 7.56191L1.33865 7.5619L1.33616 7.55627C1.32375 7.52817 1.3195 7.47587 1.33956 7.42697C3.18225 3.11338 6.40664 0.652832 9.88761 0.652832H9.89646C11.6499 0.652832 13.3216 1.26737 14.7906 2.42469ZM9.89646 3.43774C7.66159 3.43774 5.85664 5.25869 5.85664 7.5C5.85664 9.73322 7.66241 11.5534 9.89646 11.5534C12.1225 11.5534 13.9274 9.7324 13.9274 7.5C13.9274 5.25951 12.1233 3.43774 9.89646 3.43774ZM10.0251 5.77646C10.8989 5.84283 11.6011 6.58496 11.6011 7.49804C11.6011 8.44496 10.8308 9.21555 9.89752 9.21555C8.96311 9.21555 8.19984 8.45832 8.18535 7.52508C9.0934 7.36162 9.81292 6.66689 10.0251 5.77646Z",
    stroke: "#CE1111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeBorder);
export default __webpack_public_path__ + "static/media/eye_border.6a4388b1b8b52852fe128e44741b8fd9.svg";
export { ForwardRef as ReactComponent };